<router-outlet>
  <app-mask></app-mask>
  <app-spinner></app-spinner>
  <page-loader></page-loader>
  <top-loader></top-loader>
</router-outlet>
